import {
  Button,
  FormGroup,
  H1,
  H2,
  H3,
  H4,
  H5,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { Businesses } from "@just-in-types";
// import { any } from "prop-types";
import QRCode from "qrcode.react";
import * as React from "react";
import { SketchPicker } from "react-color";
import { firestore } from "../firebase";
import { ISiteNode } from "../views/Businesses";
import BusinessLogoUploader from "./BusinessLogoUploader";
import CopyLink from "./CopyLink";
import SiteAdder from "./SiteAdder";

interface IBusinessTreeProps {
  business: Businesses.Business;
  siteNodes: ISiteNode[];
}

interface CheckInsOptions {
  buttonColor : string;
  leftSideBgColor : string;
  leftSideTagColor : string;
  mainBackgroundColor : string;
  tableBackgroundColor : string;
  tableBorderColor : string;
  tableFontColor : string;
}

const emptyCheckInsOptions = {
  buttonColor:'',
  leftSideBgColor:'',
  leftSideTagColor:'',
  mainBackgroundColor:'',
  tableBackgroundColor:'',
  tableBorderColor:'',
  tableFontColor:''
}
interface CheckInsOptionsDisable {
  buttonColorDisable : boolean;
  leftSideBgColorDisable : boolean;
  leftSideTagColorDisable : boolean;
  mainBackgroundColorDisable : boolean;
  tableBackgroundColorDisable : boolean;
  tableBorderColorDisable : boolean;
  tableFontColorDisable : boolean;
}

const emptyCheckInsOptionsDisable = {
  buttonColorDisable:false,
  leftSideBgColorDisable:false,
  leftSideTagColorDisable:false,
  mainBackgroundColorDisable:false,
  tableBackgroundColorDisable:false,
  tableBorderColorDisable:false,
  tableFontColorDisable:false,
}

interface ColorPickerOptions {
  buttonColor:{
    background:string,
    onOpen:boolean,
  },
  leftSideTagColor:{
    background:string,
    onOpen:boolean,
  },
  leftSideBgColor:{
    background:string,
    onOpen:boolean,
  },
  mainBackgroundColor:{
    background:string,
    onOpen:boolean,
  },
  tableBackgroundColor:{
    background:string,
    onOpen:boolean,  
  },
  tableBorderColor:{
    background:string,
    onOpen:boolean,  
  },
  tableFontColor:{
    background:string,
    onOpen:boolean,  
  },
}



interface IBusinessTreeState {
  addaNewPickSwitch  :boolean | null;
  addaNewPickSwitchDisabled  :boolean; 
  checkInsDelay: number | null;
  checkInsDelayDisabled: boolean;
  checkInsOptions : CheckInsOptions;
  checkInsOptionsDisable : CheckInsOptionsDisable;
  colormode : boolean | null;
  colormodeDisabled  :boolean;
  colorPickerOptions: ColorPickerOptions;
  darkmode  :boolean | null;
  darkmodeDisabled  :boolean;
  enableRowInTxtMsgSwitch: boolean | null;
  enableRowInTxtMsgSwitchDisable  :boolean;
  justInKeyword: string | null;
  justInKeywordDisabled: boolean;
  markForSellingCarSwitch  :boolean | null;
  markForSellingCarSwitchDisabled  :boolean; 
  markForTheftSwitch  :boolean | null;
  markForTheftSwitchDisabled  :boolean;
  militaryFirstResopnderSwitch:boolean | null;
  militaryFirstResopnderSwitchDisabled:boolean;
  modelYearRangeSwitch:boolean | null;
  modelYearRangeSwitchDisabled:boolean;
  proMembership: boolean | null;
  proMembershipDisabled: boolean;
  s3Id: string | null;
  s3IdDisabled: boolean;
  sensitiveDataMaskingSwitch: boolean | null;
  sensitiveDataMaskingSwitchDisable: boolean;
  showSiteAdder: boolean;
  showPickLeft: boolean | null;
  urgId: string | null;
  urgIdDisabled: boolean;
}

const TextInputGroup = ({
  disabled,
  innerRef,
  name,
  onChange,
  onClick,
  value,
}: {
  disabled: boolean;
  innerRef?: (ref: HTMLInputElement | null) => HTMLInputElement | null;
  name: string;
  onChange: any;
  onClick: any;
  value: string;
}) => ( 
  <FormGroup label={name}>
    <InputGroup
      {...{ disabled, name, value }}
      inputRef={innerRef}
      onChange={onChange}
      rightElement={
        <Button
          {...{ disabled, name, onClick, value }}
          intent="primary"
          minimal={true}
        >
          change
        </Button>
      }
    />
  </FormGroup>
);

type TextInputName =
  "buttonColor"
  | "leftSideBgColor"
  | "leftSideTagColor"
  |"mainBackgroundColor"
  |"tableBackgroundColor"
  |"tableBorderColor"
  |"tableFontColor";

  const isValidTextInputName = (name: string): name is TextInputName =>
  name === "buttonColor" ||
  name === "leftSideBgColor" ||
  name === "leftSideTagColor" ||
  name === "mainBackgroundColor" ||
  name === "tableBackgroundColor" ||
  name === "tableBorderColor" ||
  name === "tableFontColor";

const TextInputGroupColor = ({
  disabled,
  innerRef,
  name,
  label,
  onChange,
  onClick,
  value,
  colorPickerOptions,
  onClickPicker,
  handleChangePicker,
}: {
  disabled: boolean;
  innerRef?: (ref: HTMLInputElement | null) => HTMLInputElement | null;
  name: TextInputName;
  label: string;
  onChange: any;
  onClick: any;
  value: string;
  colorPickerOptions: any;
  onClickPicker: any;
  handleChangePicker: any;
}) => (
  <FormGroup label={label}>
    <InputGroup
      {...{ disabled, name, value }}
      inputRef={innerRef}
      onChange={onChange}
      rightElement={
        <Button {...{ disabled, name, onClick, value }} intent="primary" minimal={true}>
          change
        </Button>
      }
    />
    <Button intent="danger" minimal={true} {...{ name, value }} onClick={onClickPicker}>
      Picker
    </Button>
    {colorPickerOptions.onOpen ? (
      <SketchPicker color={colorPickerOptions.background} onChange={(event) => handleChangePicker(event, name)} />
    ) : (
      ""
    )}
  </FormGroup>
);

export default class BusinessTree extends React.Component<
  IBusinessTreeProps,
  IBusinessTreeState
> {
  public state: IBusinessTreeState = {
    addaNewPickSwitch : false,
    addaNewPickSwitchDisabled: false,
    checkInsDelay: null,
    checkInsDelayDisabled: false,
    checkInsOptions:emptyCheckInsOptions,
    checkInsOptionsDisable : emptyCheckInsOptionsDisable,
    colorPickerOptions:{
      buttonColor:{
        background:'',
        onOpen:false
      },
      leftSideBgColor:{
        background:'',
        onOpen:false
      },
      leftSideTagColor:{
        background:'',
        onOpen:false
      },
      mainBackgroundColor:{
        background:'',
        onOpen:false
      },
      tableBackgroundColor:{
        background:'',
        onOpen:false
      },
      tableBorderColor:{
        background:'',
        onOpen:false
      },
      tableFontColor:{
        background:'',
        onOpen:false
      }
    },
    colormode : this.props.business.colormode !== undefined ? this.props.business.colormode : false,
    colormodeDisabled: false,
    darkmode : this.props.business.darkmode !== undefined ? this.props.business.darkmode : false,
    darkmodeDisabled: false,
    enableRowInTxtMsgSwitch: this.props.business.enableRowInTxtMsgSwitch !== undefined ? this.props.business.enableRowInTxtMsgSwitch : false,
    enableRowInTxtMsgSwitchDisable: false,
    justInKeyword: null,
    justInKeywordDisabled: false,
    markForSellingCarSwitch :  false,
    markForSellingCarSwitchDisabled: false,
    markForTheftSwitch : false,
    markForTheftSwitchDisabled: false,
    militaryFirstResopnderSwitch :  false,
    militaryFirstResopnderSwitchDisabled: false,
    modelYearRangeSwitch :  false,
    modelYearRangeSwitchDisabled: false,
    proMembership: this.props.business.proMembership !== undefined ? this.props.business.proMembership : false,
    proMembershipDisabled: false,
    s3Id: null,
    s3IdDisabled: false,
    sensitiveDataMaskingSwitch: false,
    sensitiveDataMaskingSwitchDisable: false,
    showPickLeft: true,
    showSiteAdder: false,
    urgId: null,
    urgIdDisabled: false,
  };

  public componentDidMount = async () => {
    const business = this.props.business as Businesses.Business;
    if (business.justInKeyword) {
      // this.buildCheckInOptions(business);
      this.setState({
        addaNewPickSwitch: business.addaNewPickSwitch !== undefined ? business.addaNewPickSwitch : false,
        colormode: business.colormode !== undefined ? business.colormode : false,
        darkmode: business.darkmode !== undefined ? business.darkmode : false,
        enableRowInTxtMsgSwitch: business.enableRowInTxtMsgSwitch !== undefined ? business.enableRowInTxtMsgSwitch : false,
        justInKeyword: business.justInKeyword,
        markForSellingCarSwitch: business.markForSellingCarSwitch !== undefined ? business.markForSellingCarSwitch : false,
        markForTheftSwitch: business.markForTheftSwitch !== undefined ? business.markForTheftSwitch : false,
        militaryFirstResopnderSwitch: business.militaryFirstResopnderSwitch !== undefined ? business.militaryFirstResopnderSwitch : false,
        modelYearRangeSwitch: business.modelYearRangeSwitch !== undefined ? business.modelYearRangeSwitch : false,
        proMembership:
          business.proMembership !== undefined ? business.proMembership : false,
        s3Id: business.s3Id !== undefined ? business.s3Id : null,
        sensitiveDataMaskingSwitch: business.sensitiveDataMaskingSwitch !== undefined ? business.sensitiveDataMaskingSwitch : false,
        showPickLeft:
          business.showPickLeft !== undefined ? business.showPickLeft : true,
        urgId: business.urgId !== undefined ? business.urgId : null,
      });
    }
    
  };

  public componentWillReceiveProps = (props: any) => {
    const business = props.business as Businesses.Business;
    if (business.justInKeyword) {
      this.buildCheckInOptions(business);
      this.setState({
        addaNewPickSwitch: business.addaNewPickSwitch !== undefined ? business.addaNewPickSwitch : false,
        colormode: business.colormode !== undefined ? business.colormode : false,
        darkmode: business.darkmode !== undefined ? business.darkmode : false,
        enableRowInTxtMsgSwitch: business.enableRowInTxtMsgSwitch !== undefined ? business.enableRowInTxtMsgSwitch : false,
        justInKeyword: business.justInKeyword,
        markForSellingCarSwitch: business.markForSellingCarSwitch !== undefined ? business.markForSellingCarSwitch : false,
        markForTheftSwitch: business.markForTheftSwitch !== undefined ? business.markForTheftSwitch : false,
        militaryFirstResopnderSwitch: business.militaryFirstResopnderSwitch !== undefined ? business.militaryFirstResopnderSwitch : false,
        modelYearRangeSwitch: business.modelYearRangeSwitch !== undefined ? business.modelYearRangeSwitch : false,
        proMembership:
          business.proMembership !== undefined ? business.proMembership : false,
        s3Id: business.s3Id !== undefined ? business.s3Id : null,
        sensitiveDataMaskingSwitch: business.sensitiveDataMaskingSwitch !== undefined ? business.sensitiveDataMaskingSwitch : false,
        showPickLeft:
          business.showPickLeft !== undefined ? business.showPickLeft : true,
        urgId: business.urgId !== undefined ? business.urgId : null,
      });
    }
  };


  public toggleSiteAdder = () =>
    this.setState(({ showSiteAdder }) => ({ showSiteAdder: !showSiteAdder }));

  public addSiteName = (siteName: string) => {
    console.log(siteName + " added");
  };

  public render() {
    const {
      business,
      business: { businessId, businessName, path },
      siteNodes,
    } = this.props;
    const {
      addaNewPickSwitch,
      checkInsDelay,
      checkInsOptions:{
        buttonColor,
        leftSideBgColor,
        leftSideTagColor,
        mainBackgroundColor,
        tableBackgroundColor,
        tableBorderColor,
        tableFontColor,
      },
      checkInsOptionsDisable:{
        buttonColorDisable,
        leftSideBgColorDisable,
        leftSideTagColorDisable,
        mainBackgroundColorDisable,
        tableBackgroundColorDisable,
        tableBorderColorDisable,
        tableFontColorDisable,
      },
      colormode,
      colorPickerOptions,
      darkmode,
      enableRowInTxtMsgSwitch,
      justInKeyword,
      markForSellingCarSwitch,
      markForTheftSwitch,
      militaryFirstResopnderSwitch,
      modelYearRangeSwitch,
      proMembership,
      justInKeywordDisabled,
      showPickLeft,
      s3Id,
      s3IdDisabled,
      sensitiveDataMaskingSwitch,
      showSiteAdder,
      urgId,
      urgIdDisabled,
    } = this.state;

    let checkQr: string | null | undefined = null;

    if (business.hasOwnProperty("s3Id")) {
      checkQr = business.s3Id ? business.s3Id : null;
    } else if (business.hasOwnProperty("urgId")) {
      checkQr = business.urgId ? business.urgId : null;
    }

    let qrUrl: string = "";
    if (checkQr) {
      qrUrl = `https://just-in.texnrewards.com/just-in/${path}`;
    }

    let isArchive: number | null | undefined = null;

    if (business.hasOwnProperty("isArchive")) {
      isArchive = business.isArchive;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "1rem",
        }}
      >
        <H1>{businessName}</H1>
        {isArchive === 1 ? (
          <Button
            intent="success"
            onClick={this.isArchiveBusiness(0)}
            style={{ marginBottom: "5px", width: "100px" }}
          >
            Restore
          </Button>
        ) : (
          <Button
            intent="danger"
            onClick={this.isArchiveBusiness(1)}
            style={{ marginBottom: "5px", width: "100px" }}
          >
            Archive
          </Button>
        )}
        <H3>Just-In keyword (ivison): </H3>
        <TextInputGroup
          disabled={justInKeywordDisabled}
          name="justInKeyword"
          onChange={this.handleJustInKeywordChange}
          onClick={this.handleJustInKeywordSubmit}
          value={justInKeyword || ""}
        />

        <H3>s3Id: </H3>
        <TextInputGroup
          disabled={s3IdDisabled}
          name="s3Id"
          onChange={this.handles3IdChange}
          onClick={this.handles3IdSubmit}
          value={s3Id || ""}
        />

        <H3>urgId: </H3>
        <TextInputGroup
          disabled={urgIdDisabled}
          name="urgId"
          onChange={this.handleurgIdChange}
          onClick={this.handleurgIdSubmit}
          value={urgId || ""}
        />

        {checkQr && (
          <div style={{ marginBottom: "2rem" }}>
            <H3>Just In QR Code</H3>
            <QRCode id="qr-code" value={qrUrl} size={200} level={"H"} />
            <p>
              <a
                style={{
                  display: "inline-block",
                  fontWeight: "bold",
                  marginTop: "5px",
                }}
                onClick={this.downloadQR}
              >
                Download QR{" "}
              </a>
            </p>
            <H3>Just in landing page link</H3>
            <CopyLink url={"https://just-in.texnrewards.com/just-in/" + path + "/-/"} />
          </div>
        )}
        <H3>Pro Member feature</H3>
        <p>
          <i>
            Will turn on the "Pro membership" button for cashiers and enable the
            feature.
          </i>
        </p>
        <Switch
          disabled={false}
          large={true}
          name="proMembership"
          onChange={this.handleProMembershipChange}
          checked={proMembership !== null ? proMembership : false}
        />
        <H3>Sensitive Data Masking Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="sensitiveDataMaskingSwitch"
          onChange={this.handlesensitiveDataMaskingSwitchChange}
          checked={sensitiveDataMaskingSwitch !== null ? sensitiveDataMaskingSwitch : false}
        />
        <H3>Just-In page Model Year Range Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="modelYearRangeSwitch"
          onChange={this.handleModelYearRangeSwitchChange}
          checked={modelYearRangeSwitch !== null ? modelYearRangeSwitch : false}
        />
        <H3>Display The Row in Just In Text Message Enable</H3>
        <Switch
          disabled={false}
          large={true}
          name="enableRowInTxtMsgSwitch"
          onChange={this.handleEnableRowInTxtMsgSwitchChange}
          checked={enableRowInTxtMsgSwitch !== null ? enableRowInTxtMsgSwitch : false}
        />
        <H2>Check in UI</H2>
        <H3>Dark Mode</H3>
        <Switch
          disabled={false}
          large={true}
          name="darkmode"
          onChange={this.handleDarkmodeChange}
          checked={darkmode !== null ? darkmode : false}
        />
        <H3>Color Mode</H3>
        <Switch
          disabled={false}
          large={true}
          name="colormode"
          onChange={this.handleColormodeChange}
          checked={colormode !== null ? colormode : false}
        />
        
        <H3>Mark For Theft Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="markForTheftSwitch"
          onChange={this.handlemarkForTheftSwitchChange}
          checked={markForTheftSwitch !== null ? markForTheftSwitch : false}
        />
        <H3>Ca$h For Car Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="markForSellingCarSwitch"
          onChange={this.handlemarkForSellingCarSwitchChange}
          checked={markForSellingCarSwitch !== null ? markForSellingCarSwitch : false}
        />
        <H3>Military / First Responder Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="militaryFirstResopnderSwitch"
          onChange={this.handleMilitaryFirstResopnderSwitchChange}
          checked={militaryFirstResopnderSwitch !== null ? militaryFirstResopnderSwitch : false}
        />
        <H3>Add a New Pick Switch</H3>
        <Switch
          disabled={false}
          large={true}
          name="addaNewPickSwitch"
          onChange={this.handleAddaNewPickSwitchChange}
          checked={addaNewPickSwitch !== null ? addaNewPickSwitch : false}
        />
        <H4>Main Background Color</H4>
        <TextInputGroupColor
          disabled={mainBackgroundColorDisable}
          name="mainBackgroundColor"
          label="Main Background Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={mainBackgroundColor || "#E5E5E5"}
          colorPickerOptions={colorPickerOptions.mainBackgroundColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Table Background Color</H4>
        <TextInputGroupColor
          disabled={tableBackgroundColorDisable}
          name="tableBackgroundColor"
          label="Table Background Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={tableBackgroundColor || "#fff"}
          colorPickerOptions={colorPickerOptions.tableBackgroundColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Table Border Color</H4>
        <TextInputGroupColor
          disabled={tableBorderColorDisable}
          name="tableBorderColor"
          label="Table Border Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={tableBorderColor || "#d2d6d9"}
          colorPickerOptions={colorPickerOptions.tableBorderColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Table Font Color</H4>
        <TextInputGroupColor
          disabled={tableFontColorDisable}
          name="tableFontColor"
          label="Table Font Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={tableFontColor || "#182026"}
          colorPickerOptions={colorPickerOptions.tableFontColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Button Color</H4>
        <TextInputGroupColor
          disabled={buttonColorDisable}
          name="buttonColor"
          label="Button Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={buttonColor || "#0d47f0"}
          colorPickerOptions={colorPickerOptions.buttonColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Left Side Tag Background Color</H4>
        <TextInputGroupColor
          disabled={leftSideTagColorDisable}
          name="leftSideTagColor"
          label="Left Side Tag Background Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={leftSideTagColor || "#5c7080"}
          colorPickerOptions={colorPickerOptions.leftSideTagColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />
        <H4>Left Side Background Color</H4>
        <TextInputGroupColor
          disabled={leftSideBgColorDisable}
          name="leftSideBgColor"
          label="Left Side Background Color"
          onChange={this.handleTextChange}
          onClick={this.handleChangeButton}
          value={leftSideBgColor || "#fff"}
          colorPickerOptions={colorPickerOptions.leftSideBgColor}
          onClickPicker={this.onClickPicker}
          handleChangePicker={this.handleChangePicker}
        />

        <H3>Delete picks after 90 days feature</H3>
        <Switch
          disabled={false}
          large={true}
          name="showPickLeft"
          onChange={this.handleShowPickLeftChange}
          checked={showPickLeft !== null ? showPickLeft : true}
        />
        <H3>Check-ins minimum delay: </H3>
        <p>
          <i>
            in minutes, the time after after a check-in before the next will
            will be allowed. (default 5 minutes)
          </i>
        </p>
        <TextInputGroup
          disabled={true}
          name="checkInsDelay"
          onChange={this.handleCheckInsDelayChange}
          onClick={this.handleCheckInsDelaySubmit}
          value={String(checkInsDelay)}
        />
        <BusinessLogoUploader businessId={businessId} />
        <br />
        <H3>kiosks</H3>
        <>
          <Button onClick={this.toggleSiteAdder}>add new kiosk</Button>
          <SiteAdder
            businessId={businessId}
            businessPath={path}
            onAddSite={this.addSiteName}
            onToggleShow={this.toggleSiteAdder}
            show={showSiteAdder}
          />
        </>
        {siteNodes.map(({ id, label, nodeData: { url } }) => (
          <div
            key={id}
            style={{
              display: "grid",
              gridTemplateColumns: "8rem 1fr",
              margin: "0.5rem 0",
            }}
          >
            <H5>{label}</H5>
            <CopyLink url={url} />
          </div>
        ))}
      </div>
    );
  }

  private handleTextChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;

    if (isValidTextInputName(name)) {
      const checkInsOptions: any = { ...this.state.checkInsOptions };

      checkInsOptions[name] = value;

      this.setState({ checkInsOptions });
    }
  };


  private handleChangeButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name, value } = event.currentTarget;
    const businessId = this.props.business.businessId;

    if (isValidTextInputName(name)) {

      const checkInsOptions: CheckInsOptions = this.state.checkInsOptions;

      console.log(value);
      // checkInsOptions[name] = value;
      
      // this.setState({ checkInsOptions });

      firestore
      .collection("businesses")
      .doc(businessId)
      .update({ checkInsOptions }).then(() => {
        console.log("Document successfully updated!");
      })
      .then(() => {
        console.log("changed checkInsOptions " + checkInsOptions[name]);
        setTimeout(() => location.reload(), 1000);
      })
      .catch((error) => {
          console.error("Error updating document: ", error);
      });

    }
  };


  private onClickPicker = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name } = event.currentTarget;
    if (isValidTextInputName(name)) {
      const colorPickerOptions = { ...this.state.colorPickerOptions };
      colorPickerOptions[name].onOpen = !colorPickerOptions[name].onOpen;
      this.setState({ colorPickerOptions });
    }
  };  
  private handleChangePicker = (color, name: string) => {
    if (isValidTextInputName(name)) {
      const colorPickerOptions = { ...this.state.colorPickerOptions };
      colorPickerOptions[name].background = color.hex;

      const checkInsOptions = { ...this.state.checkInsOptions };
      checkInsOptions[name] = color.hex;
      this.setState({ colorPickerOptions, checkInsOptions });
    }
  };

  private handleCheckInsDelayChange = (event) => {
    const value = event.currentTarget.value;
    this.setState({ checkInsDelay: Number(value) });
  };

  private handleCheckInsDelaySubmit = async (event) => {
    const businessId = this.props.business.businessId;
    const { checkInsDelay } = this.state;
    this.setState({ checkInsDelayDisabled: true });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({
        checkInsDelay,
      })
      .then(() => {
        console.log("changed checkins delay to " + checkInsDelay);
        setTimeout(() => location.reload(), 1000);
      });
  };
  private handleJustInKeywordChange = (event) => {
    const value = event.currentTarget.value;
    this.setState({ justInKeyword: value });
  };

  private handleJustInKeywordSubmit = async (event) => {
    const businessId = this.props.business.businessId;
    const { justInKeyword } = this.state;
    this.setState({ justInKeywordDisabled: true });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({
        justInKeyword,
      })
      .then(() => {
        console.log("changed justInKeyword to " + justInKeyword);
        setTimeout(() => location.reload(), 1000);
      });
  };

  private buildCheckInOptions = (business) => {
    const chkOptions = business.checkInsOptions;
    const checkInsOptions : CheckInsOptions = {
      buttonColor: '',
      leftSideBgColor: '',
      leftSideTagColor: '',
      mainBackgroundColor: '',
      tableBackgroundColor: '',
      tableBorderColor: '',
      tableFontColor: '',
    }

    if(chkOptions !== undefined){
      if('buttonColor' in chkOptions){
        checkInsOptions.buttonColor = chkOptions.buttonColor;
      }  
      if('leftSideBgColor' in chkOptions){
        checkInsOptions.leftSideBgColor = chkOptions.leftSideBgColor;
      }  
      if('leftSideTagColor' in chkOptions){
        checkInsOptions.leftSideTagColor = chkOptions.leftSideTagColor;
      }  
      if('mainBackgroundColor' in chkOptions){
        checkInsOptions.mainBackgroundColor = chkOptions.mainBackgroundColor;
      }  
      if('tableBackgroundColor' in chkOptions){
        checkInsOptions.tableBackgroundColor = chkOptions.tableBackgroundColor;
      }  
      if('tableBorderColor' in chkOptions){
        checkInsOptions.tableBorderColor = chkOptions.tableBorderColor;
      }  
      if('tableFontColor' in chkOptions){
        checkInsOptions.tableFontColor = chkOptions.tableFontColor;
      }  
    }

    this.setState({ checkInsOptions});
  }

  private handles3IdChange = (event) => {
    const value = event.currentTarget.value;
    this.setState({ s3Id: value });
  };

  private handles3IdSubmit = async (event) => {
    const businessId = this.props.business.businessId;
    const { s3Id } = this.state;
    this.setState({ s3IdDisabled: true });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({
        s3Id,
      })
      .then(() => {
        console.log("changed s3Id to " + s3Id);
        setTimeout(() => location.reload(), 1000);
      });
  };

  private handleurgIdChange = (event) => {
    const value = event.currentTarget.value;
    this.setState({ urgId: value });
  };

  private handleurgIdSubmit = async (event) => {
    const businessId = this.props.business.businessId;
    const { urgId } = this.state;
    this.setState({ urgIdDisabled: true });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({
        urgId,
      })
      .then(() => {
        console.log("changed urgId to " + urgId);
        setTimeout(() => location.reload(), 1000);
      });
  };

  private handleProMembershipChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ proMembership: checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ proMembership: checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };

  private handleDarkmodeChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ darkmode : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ darkmode : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handleModelYearRangeSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ modelYearRangeSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ modelYearRangeSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handleEnableRowInTxtMsgSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ enableRowInTxtMsgSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ enableRowInTxtMsgSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handlesensitiveDataMaskingSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ sensitiveDataMaskingSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ sensitiveDataMaskingSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handlemarkForTheftSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ markForTheftSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ markForTheftSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handleAddaNewPickSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ addaNewPickSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ addaNewPickSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };
  private handlemarkForSellingCarSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ markForSellingCarSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ markForSellingCarSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };

  private handleMilitaryFirstResopnderSwitchChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ militaryFirstResopnderSwitch : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ militaryFirstResopnderSwitch : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };

  private handleColormodeChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    this.setState({ colormode : checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ colormode : checked }).then(() => {
        console.log("Document successfully updated!");
    })
    .catch((error) => {
        console.error("Error updating document: ", error);
    });
  };

  private handleShowPickLeftChange = (event) => {
    const businessId = this.props.business.businessId;
    const { checked } = event.currentTarget;
    console.log(checked);
    this.setState({ showPickLeft: checked });
    firestore
      .collection("businesses")
      .doc(businessId)
      .update({ showPickLeft: checked });
  };

  private downloadQR = () => {
    const canvas = document.getElementById("qr-code") as HTMLCanvasElement;
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "qr.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  private isArchiveBusiness = (val: number) => (e) => {
    const businessId = this.props.business.businessId;

    if (val === 1) {
      if (!confirm("Are you sure?")) {
        return;
      }
    }

    firestore
      .collection("businesses")
      .doc(businessId)
      .update({
        isArchive: val,
      })
      .then(() => {
        console.log("changed isArchive to " + val);
        setTimeout(() => location.reload(), 1000);
      });
  };
}



// WEBPACK FOOTER //
// ./src/components/BusinessTree.tsx